import React from "react";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { GET_ORDER_CANCELLATION_CHARGES } from "./graphql";
import { rupees } from "./controls";
import { StatusChip, WaiveButton } from "./ChargesRecord";

// Booking details (OrderDetailsModal): the cancellation fee / Barbera credit
// worked out for this booking, with the reasoning and a Waive button.
const OrderCancellationFee = ({ orderId }) => {
  const { data, loading, refetch } = useQuery(GET_ORDER_CANCELLATION_CHARGES, { variables: { orderId }, fetchPolicy: "network-only" });
  const rows = data?.getOrderCancellationCharges?.rows || [];
  if (loading && !rows.length) return <p className="text-gray-400 text-sm">Loading cancellation fee…</p>;
  if (!rows.length) {
    return <p className="text-gray-400 text-sm">Not judged - cancelled before the cancellation policy was switched on, or with no fault category.</p>;
  }
  return (
    <div className="space-y-2">
      {rows.map((r) => (
        <div key={r.id} className={`bg-[#2a2a2a] rounded-lg p-3 text-sm border-l-4 ${r.kind === "CREDIT" ? "border-l-sky-400" : r.finalAmount > 0 ? "border-l-amber-400" : "border-l-gray-500"}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="text-white font-semibold">
              {r.kind === "CREDIT" ? `Customer credit ${rupees(r.finalAmount)}` : r.finalAmount > 0 ? `Fee ${rupees(r.finalAmount)}` : "No fee"}
              <span className="text-gray-400 font-normal"> · {r.ruleLabel}</span>
            </span>
            <span className="flex items-center gap-2">
              <StatusChip row={r} />
              <WaiveButton row={r} onDone={() => refetch()} />
            </span>
          </div>
          <ul className="mt-2 text-xs text-gray-300 list-disc pl-4 space-y-0.5">
            {r.explanation.map((l, i) => <li key={i}>{l}</li>)}
          </ul>
          {r.status === "WAIVED" && <p className="text-xs text-violet-300 mt-1">Waived by {r.waivedBy || "an admin"}: {r.waiveReason}</p>}
          {r.mode === "SHADOW" && <p className="text-[11px] text-gray-500 mt-1">Shadow mode - recorded only, the customer was not charged.</p>}
        </div>
      ))}
      <Link to="/admin/cancellation-policy" className="text-xs text-[#FBB033] hover:underline">Cancellation policy →</Link>
    </div>
  );
};

export default OrderCancellationFee;
